import { render, staticRenderFns } from "./MerchantCred.vue?vue&type=template&id=67f120a8"
import script from "./MerchantCred.vue?vue&type=script&lang=js"
export * from "./MerchantCred.vue?vue&type=script&lang=js"
import style0 from "./MerchantCred.vue?vue&type=style&index=0&id=67f120a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports